<template>
  <div>
    <el-table :data="orderList"  size="small" border>
      <!-- <el-table-column prop="id"  label="订单ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="fromUserId" label="转出账号"></el-table-column> -->
      <el-table-column prop="coinType" label="币种" fixed></el-table-column>
      <el-table-column prop="chain" label="链" fixed></el-table-column>
      <el-table-column prop="balance" label="地址余额" fixed></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" fixed></el-table-column>
      <el-table-column label="余额详情" align="center">
        <template slot-scope="scope">
          <el-button size="small" circle type="primary" icon="el-icon-view" @click="checkDetail(scope.row)"></el-button>
        </template>
      </el-table-column>
 


     
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <el-dialog title="余额详情" :visible.sync="dialogTableVisible" :before-close="handleClose">
      <el-input v-model="address" style="width:350px;margin-right: 20px;" clearable placeholder="输入address地址"></el-input>
  <el-button type="primary" style="margin-right:20px" @click="searchDetail">搜索</el-button>
  <a  @click="getExcelDetail" target="_blank" >导出Excel</a>
      <el-table :data="detailList" max-height="500px">
    <el-table-column property="address" label="地址" width="380"></el-table-column>
    <el-table-column property="balance" label="余额" ></el-table-column>
    <el-table-column property="updateTime" label="更新时间"></el-table-column>

  </el-table>
  <pagination
      :size="sizeDetail"
      :total="totalCountDetail"
      :page="pageDetail"
      @pageChanged="pageChangedDetail"
    ></pagination>
</el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'AddressBalanceList',
// props:['coinType','chain'],
  data() {
    return {
      page:1,size:25,
      pageDetail:1,
      sizeDetail:10,
      address:'',
      coinType:'',
      chain:'',
      dialogTableVisible:false
    };
  }, 
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('addressBlance', [
      'updateDividendStatus',
      'updateMark','getDetail','exportExcel'
    ]),
    ...mapMutations('addressBlance', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    pageChanged(e) {
      this.page=e.page
      this.size=e.size
      this.$emit('refresh', {page:this.page,size:this.size});
    },
    pageChangedDetail(e){
      this.pageDetail=e.page
      this.sizeDetail=e.size
      this.getDetail({...e,coinType:this.coinType,chain:this.chain,address:this.address})
    },
    handleDel(row){
    },
    searchDetail(data={}){
      this.getDetail({page:1,size:25,coinType:this.coinType,chain:this.chain,address:this.address,...data})
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
    checkDetail(row){
      console.log('row',row);
      this.coinType=row.coinType
      this.chain=row.chain
      this.dialogTableVisible=true
    this.getDetail({page:1,size:10,coinType:row.coinType,chain:row.chain,address:''}).then(res=>{
      console.log(res);
    })
    this.pageDetail=1
    this.sizeDetail=10
    },
    getExcelDetail(){
      console.log('this.cointype',this.coinType,this.chian);
      this.exportExcel({
        coinType:this.coinType,
        chain:this.chain,
        address:this.address
      }).then(res=>{
        const link=document.createElement('a') 
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
            link.style.display = 'none'
            // 设置连接
            link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
            console.log('link-href',link.href);
            link.download = `${this.coinType}地址余额明细报表`
            document.body.appendChild(link)
            // 模拟点击事件
            link.click()  //设置点击事件
         
      })
    }
   
  },
  computed: {
    ...mapGetters('addressBlance', ['userList',]),
    ...mapState('addressBlance', [
      'pagination',
      'totalCount','totalCountDetail',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList','orderList','detailList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
